const MAX_RANGE = 500; // largest allowed span, e.g. 1-501 is rejected

/**
 * Parse a Ref. IDs string such as "220, 221 or 220-222".
 *
 * Returns:
 *   { ids: null }          -> input is empty (no filtering)
 *   { ids: Set<string> }   -> every ID, ranges expanded
 *   { error: string }      -> message to show the user
 */
const parseIds = (text) => {
  const cleaned = String(text ?? "")
    .trim()
    .replace(/\s*-\s*/g, "-");
  if (!cleaned) return { ids: null };

  const ids = new Set();

  for (const token of cleaned.split(/[\s,]+/).filter(Boolean)) {
    const range = token.match(/^(\d+)-(\d+)$/);

    if (range) {
      const start = Number(range[1]);
      const end = Number(range[2]);

      if (start > end) {
        return { error: `"${token}" is not a valid range. Start must be lower than end.` };
      }
      if (end - start > MAX_RANGE) {
        return { error: `"${token}" is too large. A range can span at most ${MAX_RANGE} IDs.` };
      }
      for (let i = start; i <= end; i++) ids.add(String(i));
    } else if (/^\d+$/.test(token)) {
      ids.add(token);
    } else {
      return { error: `"${token}" is not a valid ID. Use 220, 221 or 220-222.` };
    }
  }

  return { ids };
};

export default parseIds;